import React, { Fragment, useState, useEffect } from "react";
import { reportImg } from "../Elite/imageAssets";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const initialCardData = [
  {
    name: "Design",
    imageUrl: reportImg,
    pageUrl: "/MIS/design",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "Sales",
    imageUrl: reportImg,
    pageUrl: "/MIS/sales",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "Audit & Training",
    imageUrl: reportImg,
    pageUrl: "/MIS/auditTraining",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "Insurance",
    imageUrl: reportImg,
    pageUrl: "/MIS/insurance",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "Dispatch",
    imageUrl: reportImg,
    pageUrl: "/MIS/dispatch",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "PPC-1",
    imageUrl: reportImg,
    pageUrl: "/MIS/ppc-1",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "Lead & Enquiry Overview",
    imageUrl: reportImg,
    pageUrl: "/MIS/leadEnquiry",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: " HR Recruitment Analysis",
    imageUrl: reportImg,
    pageUrl: "/MIS/recruitment",
    isHoverCard: false,
    isVisible: false,
  },
];

const MISDashboard = () => {
  const navigate = useNavigate();
  const userApps = useSelector(
    (state) => state.loginReducer.loginDetials.userApplications
  );
  const [cardData, setCardData] = useState(initialCardData);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (userApps && userApps.length > 0) {
      // Find the MIS Dashboard app (by ID or by name)
      const misApp =
        userApps.find(
          (x) =>
            x.aP_Id === 14 ||
            x.aP_Name.toLowerCase().includes("mis - dashboard")
        ) || {};

      const tempMISData = misApp.features || [];

      const updatedMISCardData = initialCardData.map((card) => {
        const cardName = card.name.toLowerCase();

        const hasDesign = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("design")
        );
        const hasSales = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("sales")
        );
        const hasAuditTraining = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("audit")
        );
        const hasInsurance = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("insurance")
        );
        const hasDispatch = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("dispatch")
        );
        const hasPPC1 = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("ppc")
        );
        const hasLeadEnquiry = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("lead")
        );
        const hasHrRecruitment = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("recruitment")
        );
        const isVisible =
          (hasDesign && cardName.includes("design")) ||
          (hasSales && cardName.includes("sales")) ||
          (hasAuditTraining && cardName.includes("audit")) ||
          (hasInsurance && cardName.includes("insurance")) ||
          (hasDispatch && cardName.includes("dispatch")) ||
          (hasPPC1 && cardName.includes("ppc")) ||
          (hasLeadEnquiry && cardName.includes("lead")) ||
          (hasHrRecruitment && cardName.includes("recruitment"));

        return { ...card, isVisible };
      });

      setCardData(updatedMISCardData);
    }
  }, [userApps]);

  const handleMouseEnter = (index) => {
    const updatedData = cardData.map((item, i) =>
      i === index ? { ...item, isHoverCard: true } : item
    );
    setCardData(updatedData);
  };

  ///// mouse leave effect code
  const handleMouseLeave = (index) => {
    const updatedData = cardData.map((item, i) =>
      i === index ? { ...item, isHoverCard: false } : item
    );
    setCardData(updatedData);
  };

  return (
    <Fragment>
      <div className="dashboard app-content content">
        <div className="content-wrapper">
          <div className="content-body">
            <div className="row">
              {cardData.map((item, i) => {
                return (
                  <>
                    {item.isVisible && (
                      <div className="col-xl-3 col-lg-6 col-12" key={i}>
                        <div
                          className={`card card-hover cur_point ${
                            item.isHoverCard ? "hovered" : ""
                          }`}
                          onClick={() => navigate(item.pageUrl)}
                          onMouseEnter={() => handleMouseEnter(i)}
                          onMouseLeave={() => handleMouseLeave(i)}
                        >
                          <div className="card-content">
                            <div className="card-body d-flex justify-content-between card_text">
                              <img src={item.imageUrl} alt="img" />
                              <h4 className="text-info pt-15">{item.name}</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default MISDashboard;
